module.exports = __webpack_public_path__ + "static/icon-nausea.9d162e93.svg";